module.exports = __webpack_public_path__ + "img/hsbc.28601036.png";